<template>
  <article
    v-if="notification"
    :class="getClasses"
  >
    <header>{{ notification.title }}</header>

    <p>
      {{ notification.body }}
    </p>

    <VButton
      v-if="showCollapseButton"
      theme="link"
      icon-postfix
      @click="toggleCollapse"
    >
      <template #icon>
        <VIcon material="keyboard_arrow_down" />
      </template>
      {{ this.collapsed ? 'Показать больше' : 'Скрыть' }}
    </VButton>

    <footer>
      <VButton
        v-if="notification.isReaded"
        theme="link"
        title="Отметить непрочитанным"
        @click="toggleReaded"
      >
        <template #icon>
          <VIcon material="radio_button_unchecked" />
        </template>
      </VButton>

      <VButton
        v-else
        theme="link"
        title="Отметить прочитанным"
        @click="toggleReaded"
      >
        <template #icon>
          <VIcon
            material="check_circle"
            theme="outlined"
          />
        </template>
      </VButton>

      <VButton
        theme="link"
        title="Удалить"
        @click="deleteNotification"
      >
        <template #icon>
          <VIcon
            material="delete"
            theme="outlined"
          />
        </template>
      </VButton>
    </footer>
  </article>
</template>

<script>
export default {
	name: 'VNotificationItem',
	props: {
		notification: {
			type: Object,
			default: null,
		},
	},

	data() {
		return {
			collapsed: true,
		};
	},

	computed: {
		getClasses() {
			return {
				'notification-component': true,
				'priority-high': this.notification.priority === 'high',
				unreaded: !this.notification.isReaded,
				uncollapsed: this.showCollapseButton && !this.collapsed,
				'with-collapse-btn': this.showCollapseButton,
			};
		},
		showCollapseButton() {
			return this.notification.body.length > 160;
		},
	},

	methods: {
		toggleCollapse() {
			this.collapsed = !this.collapsed;
		},
		toggleReaded() {
			const notification = { ...this.notification };
			notification.isReaded = !notification.isReaded;
			this.$emit('update:notification', notification);
		},
		deleteNotification() {
			this.$emit('delete', this.notification);
		},
	},
};
</script>

<style lang="scss" scoped></style>
